import { defineMigrations } from "@supersig/store";
/** @public */ export const videoNodeProps = {};
const Version = {
    AddProps: 1
};
/** @internal */ export const videoNodeMigrations = defineMigrations({});
export const VideoNodeInfo = {
    migrations: videoNodeMigrations,
    props: videoNodeProps,
    meta: {}
};
